/**
 * The Inventory Audit page's Alerts button: a deep link to the dealer's
 * Scheduled Reports page, where the morning audit alerts live (revenue-
 * assurance plan, Phase 2). Sits beside Help in the page header
 * and copies its style (AuditHelpButton.tsx:31-44) so the header reads as one
 * row of controls. The page owns the navigation; this only reports the click.
 */
import React from "react"
import { Mail } from "lucide-react"

import { THEME } from "../../config/theme"

interface Props {
  onOpen: () => void
}

export default function AuditAlertsButton({ onOpen }: Props) {
  return (
    <button
      type="button"
      onClick={onOpen}
      title="Who gets emailed about which problems, every morning"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "7px 14px",
        fontSize: 13,
        fontWeight: 500,
        fontFamily: THEME.fonts.primary,
        borderRadius: THEME.borderRadius.sm,
        border: `1px solid ${THEME.colors.silver}`,
        background: THEME.colors.white,
        color: THEME.colors.neutral.light.textPrimary,
        cursor: "pointer",
      }}
    >
      <Mail size={15} />
      Alerts
    </button>
  )
}
